var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPupilLeft = function SvgPupilLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 52,
    height: 19,
    viewBox: "0 0 2.12 0.78",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2374310986912"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.91.36C.94.38.82.51.78.55.48.81.34.65.1.34.34.02.58.02.91.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "str0",
    d: "M1.2.36c-.03.02.09.15.14.19.3.26.43.1.67-.21-.24-.32-.47-.32-.81.02z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M.48.25C.27.3.41.63.6.49.73.39.6.22.48.25z"
  })))));
};

export default SvgPupilLeft;